module.exports = __webpack_public_path__ + "img/795e3cf24e36adb3770dfeddfcfce2a3.png";